import React, { useState, useEffect, useRef } from 'react';

const useLocalStorage = (
  keyString: string,
  defaultValue?: string,
): [
  string | undefined,
  React.Dispatch<React.SetStateAction<string | undefined>>,
] => {
  const [localData, setLocalData] = useState<string | undefined>(undefined);
  const currentDataRef = useRef<string>();

  useEffect(() => {
    const localValue = localStorage.getItem(keyString);

    if (localValue) {
      setLocalData(localValue);
    } else {
      setLocalData(
        defaultValue ?? (keyString.startsWith('is_') ? 'false' : undefined),
      );
    }
  }, []);

  useEffect(() => {
    if (localData !== currentDataRef.current) {
      currentDataRef.current = localData;
      localData && localStorage.setItem(keyString, localData);
    }
  }, [localData]);

  return [localData, setLocalData];
};

export default useLocalStorage;
